import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Environment } from '../../../typings';
import { EnvironmentToken } from '../../../util';
import { Subscription } from 'rxjs';
import { SharedDataService } from '../gather-services/shared-data.service';
import { JobPosting } from '../gather-typings';

@Component({
    selector: 'app-gather-invalid-uuid',
    templateUrl: './gather-invalid-uuid.component.html',
    styleUrls: ['./gather-invalid-uuid.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GatherInvalidUuidComponent implements OnInit {
  JOB_CENTER_PATH = '/myaquent?PROC=AWUIDrawAdvancedJobSearch';

  private subscriptions = new Subscription();
  private jobPosting: JobPosting;

  constructor(private sharedDataService: SharedDataService, @Inject(EnvironmentToken) private environment: Environment) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.sharedDataService.jobPosting.subscribe(posting => {
        this.jobPosting = posting;
      })
    );
  }

  goToJobCenter() {
    window.open(this.environment.matHost + this.JOB_CENTER_PATH, '_blank');
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
